import React from 'react';
import { HelpCircle, ChevronDown } from 'lucide-react';

const FAQSection = ({ event, pc, bg }) => {
    const isEnabled = event?.faqs_enabled;
    const faqs = event?.faqs || [];

    if (!isEnabled || faqs.length === 0) {
        return null;
    }

    const iconBgColor = pc ? `${pc}33` : 'rgba(0,0,0,0.1)';

    return (
        <section className="py-24 px-6" style={{ backgroundColor: bg }}>
            <div className="max-w-3xl mx-auto">
                <div className="text-center mb-16">
                    <div
                        className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 transition-transform hover:scale-110"
                        style={{ backgroundColor: iconBgColor }}
                    >
                        <HelpCircle className="w-8 h-8" style={{ color: pc }} />
                    </div>
                    <h2 className="font-heading text-4xl text-wedding-text mb-4">Preguntas Frecuentes</h2>
                    <p className="text-wedding-text-muted">Despeja tus dudas sobre nuestro gran día</p>
                </div>

                <div className="space-y-4">
                    {faqs.map((faq, i) => (
                        <details
                            key={i}
                            className="group bg-white/80 backdrop-blur-md rounded-2xl p-6 shadow-md border border-white/50 cursor-pointer overflow-hidden transition-all duration-300 open:shadow-xl"
                        >
                            <summary className="flex items-center justify-between font-heading text-lg text-wedding-text list-none outline-none">
                                <span className="pr-4">{faq.question}</span>
                                <ChevronDown className="w-5 h-5 transition-transform duration-300 group-open:rotate-180 text-wedding-text-muted" />
                            </summary>
                            <div className="mt-4 text-wedding-text-muted border-t border-wedding-accent/10 pt-4 leading-relaxed animate-in fade-in slide-in-from-top-2">
                                {faq.answer}
                            </div>
                        </details>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQSection;
